import { TViewCommonOption } from '@libs/types';
import clsx from 'clsx';
import React from 'react';
import { CoreTextView } from '@core/widgets';
import { TextStyle } from '../../../types/styles';
import styles from './tag.module.css';

type TTagProps = {
    metaText?: string;
    metaVariant?: 'text' | 'tag';
    metaHierarchy?: 'primary' | 'secondary' | 'inverted';
    size?: 'default' | 'small';
} & Pick<TViewCommonOption, 'styleName' | 'parentStyleNames' | 'isDisabled'>;

const getTagColor = (props: TTagProps): string => {
    if (props.metaVariant === 'tag') {
        if (props.metaHierarchy === 'inverted') {
            return props.isDisabled ? 'purple_40_tr' : 'purple_100';
        }
        return props.isDisabled ? 'white_40_tr_base' : 'white_base';
    }
    if (props.metaHierarchy === 'secondary') {
        return props.isDisabled ? 'grey_40_lc' : 'grey_72_lc';
    }
    return props.isDisabled ? 'grey_40_lc' : 'black';
};

export const Tag = (props: TTagProps) => {
    const isTagVariant = props.metaVariant === 'tag';
    const isTagSecondary = isTagVariant && props.metaHierarchy === 'secondary';
    const isTagInverted = isTagVariant && props.metaHierarchy === 'inverted';

    return (
        <span
            className={clsx(
                styles.tagContainer,
                isTagVariant && (props.size === 'small' ? styles.tagSmall : styles.tagDefault),
                isTagVariant && styles.bgTag,
                isTagSecondary && styles.bgTagSecondary,
                isTagInverted && styles.bgTagInverted,
                props.isDisabled && styles.bgTagDisabled,
            )}
        >
            <CoreTextView
                text={props.metaText}
                as="p"
                parentStyleNames={props.parentStyleNames}
                styleName={props.styleName}
                styleProps={{
                    ...(isTagVariant ? TextStyle.tag : TextStyle.main),
                    main: `var(--color-${getTagColor(props)})`,
                    textTransform: isTagVariant ? 'uppercase' : undefined,
                }}
            />
        </span>
    );
};
